import { Brick, registerBrick } from 'olympe';

export default class RGGetChangeMetadata extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!RGChange} change
     * @param {function(!Object)} setNewCell
     * @param {function(!Object)} setPreviousCell
     * @param {function(string|number)} setRowId
     * @param {function(string|number)} setColumnId
     * @param {function(string)} setType
     */
    update(_$, [change], [setNewCell, setPreviousCell, setRowId, setColumnId, setType]) {
        setNewCell(change.metadata.newCell);
        setPreviousCell(change.metadata.previousCell);
        setRowId(change.metadata.rowId);
        setColumnId(change.metadata.columnId);
        setType(change.metadata.type);
    }
}

registerBrick('01920a4d4d8390252c91', RGGetChangeMetadata);
